import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Icon,
  Segment,
} from 'semantic-ui-react';
import LoadImage from './LoadImage';
import LoanAmount from './LoanAmount';
import CurrencySymbol from './CurrencySymbol';
import BuyerBankerCard from './BuyerBankerCard';

import { REJECTED_STATUSES } from '../constants/bankCaseStatuses';

export default class BuyerLoanCard extends Component {
  static propTypes = {
    loans: PropTypes.arrayOf(PropTypes.shape({
      loan: PropTypes.object,
      loan_rate_points: PropTypes.number,
      loan_amount: PropTypes.number,
      loan_years: PropTypes.number,
      imgs_thumb: PropTypes.object,
    })),
    bankCases: PropTypes.arrayOf(PropTypes.shape({})),
    onAssign: PropTypes.func,
    onMessage: PropTypes.func,
    onNudge: PropTypes.func,
    onUpdateStatus: PropTypes.func,
    projectCurrencies: PropTypes.arrayOf(PropTypes.object),
    isSold: PropTypes.bool,
    disabled: PropTypes.bool,
  }
  static defaultProps = {
    loans: [],
    bankCases: [],
    isSold: false,
    disabled: false,
  }

  static getPropsToState = (props) => {
    const { loans, bankCases } = props;
    let data = loans.find(l => !REJECTED_STATUSES.some(s => s === l.status));
    if (!data) {
      data = loans[0];
    }
    const isActive = data && data.status ? (
      !REJECTED_STATUSES.some(s => s === data.status) &&
      data.case_id > 0 && data.case_id !== ''
    ) : false;
    const cancelledLoans = loans.reduce((result, la) => {
      const app = la;
      if (la.case_id > 0) {
        const bankCase = bankCases.find(bc => bc.id === la.case_id);
        if (bankCase) {
          app.bankCase = bankCase;
        }
      }
      if (app.id !== data.id) {
        result.push(app);
      } else if (!isActive && app.case_id > 0) {
        result.push(app);
      }
      return result;
    }, []);
    if (isActive) {
      const bankCase = bankCases.find(bc => bc.id === data.case_id);
      if (bankCase) {
        data.bankCase = bankCase;
      }
    }
    return {
      isActive,
      data,
      cancelledLoans,
    };
  }
  constructor(props) {
    super(props);
    const state = BuyerLoanCard.getPropsToState(props);
    this.state = {
      ...state,
      showHistory: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = BuyerLoanCard.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  handleOnAssign = (e) => {
    const { onAssign } = this.props;
    const { data } = this.state;
    if (onAssign) {
      onAssign(e, data);
    }
  }

  handleToggleHistory = () => {
    const { showHistory } = this.state;
    this.setState({ showHistory: !showHistory });
  }

  calculateMonthlyPayment = (
    loanCents,
    interest,
    years,
    multiplier = 1000,
  ) => {
    const months = years * 12;
    if (interest === 0) {
      return loanCents / months;
    }
    const rate = ((interest / multiplier) / 100) / 12;
    const x = (1 + rate) ** months;
    return parseInt((rate / (x - 1)) * loanCents * x, 10);
  }

  renderHistoryButton = () => {
    const { disabled } = this.props;
    const { showHistory } = this.state;
    return (
      <Button
        as={Button}
        basic
        compact
        className="show-history"
        onClick={this.handleToggleHistory}
        disabled={disabled}
      >
        <Icon name={showHistory ? 'chevron up' : 'chevron down'} />
        {showHistory ? 'Hide' : 'View'} History
      </Button>
    );
  }

  render() {
    const { projectCurrencies, onUpdateStatus, onMessage, onNudge, isSold, disabled } = this.props;
    const { data, isActive, cancelledLoans, showHistory } = this.state;
    return (
      <Segment.Group className="buyer-loan-card">
        <Segment className="headers" title={data && data.loan ? data.loan.name : ''}>
          {
            data && data.loan ? (
              <div className="row">
                {
                  data.loan.imgs_thumb ? (
                    <LoadImage
                      shape="circular"
                      src={data.loan.imgs_thumb.x010}
                    />
                  ) : null
                }
                <span>{data.loan.name}</span>
              </div>
            ) : null
          }
        </Segment>
        <Segment className="details">
          <Grid>
            {
              data && !data.is_sr ? (
                <Grid.Row verticalAlign="bottom">
                  <Grid.Column>
                    Monthly Repayment:
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    <LoanAmount
                      projectCurrencies={projectCurrencies}
                      amount={(this.calculateMonthlyPayment(data.loan_amount, data.loan_rate_points, data.loan_years) || 0) / 100}
                      format="0,000,000.00"
                      prefix={<CurrencySymbol />}
                    />
                  </Grid.Column>
                </Grid.Row>
              ) : null
            }
            {
              data && !data.is_sr ? (
                <Grid.Row verticalAlign="bottom">
                  <Grid.Column>
                    Interest Rate:
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    {data.loan_rate_points ? `${data.loan_rate_points / 1000} % P.A.` : '-'}
                  </Grid.Column>
                </Grid.Row>
              ) : null
            }
            <Grid.Row verticalAlign="bottom">
              <Grid.Column>
                Borrowing:
              </Grid.Column>
              <Grid.Column textAlign="right">
                <LoanAmount
                  projectCurrencies={projectCurrencies}
                  amount={data ? (data.loan_amount || 0) / 100 : 0}
                  format="0,000,000"
                  prefix={<CurrencySymbol />}
                />
              </Grid.Column>
            </Grid.Row>
            {
              data && !data.is_sr && data.loan_years ? (
                <Grid.Row className="years">
                  <Grid.Column width={16} textAlign="right">
                    Over {data.loan_years} years
                  </Grid.Column>
                </Grid.Row>
              ) : null
            }
          </Grid>
          {
            !isSold && !isActive ? (
              <Button
                className="assign"
                fluid
                color="blue"
                onClick={this.handleOnAssign}
                content="Assign Banker"
                disabled={disabled || isSold}
              />
            ) : null
          }
          {
            !isActive && cancelledLoans.length > 0 ? this.renderHistoryButton() : null
          }
        </Segment>
        {
          isActive && data && data.bankCase ? (
            <Segment>
              <BuyerBankerCard
                data={data}
                onChangeStatus={onUpdateStatus}
                onMessage={onMessage}
                onNudge={onNudge}
                isSold={isSold}
                disabled={disabled}
              />
              {
                cancelledLoans.length > 0 ? this.renderHistoryButton() : null
              }
            </Segment>
          ) : null
        }
        {
          showHistory && cancelledLoans.length > 0 ? cancelledLoans.map((l, i) => (
            <Segment key={i}>
              <BuyerBankerCard
                data={l}
                disabled
              />
            </Segment>
          )) : null
        }
      </Segment.Group>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BuyerLoanCard.jsx